import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PassTypeMarket({passType}) {
    const { t } = useTranslation()
    const {commission} = useSelector(state=>state.commissions)
    
    const backCardImage = {
        backgroundImage: passType?.image ? `url(${passType?.image})` : `url("/images/bannerclub.jpg")`,        
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    }

    const calculatePrice = (price) => {
        if (price <= 0) {
            return 0.00
        } else {
            const basePrice = parseFloat(price)
            const ticketingCommission = commission?.ticketing?.find(activity => basePrice >= activity.lowPrice && basePrice <= activity.highPrice);
            return (Math.ceil((parseFloat(basePrice) + parseFloat(basePrice * (ticketingCommission?.percentage || 0) / 100) + parseFloat(ticketingCommission?.double || 0)) * 100) / 100).toFixed(2)
        }
    }

    // Obtener el precio mínimo de todas las temporadas
    const getMinPrice = () => {
        if (!passType?.seasons || passType.seasons.length === 0) {
            return passType?.price || 0
        }
        const prices = passType.seasons.map(season => season.price || 0)
        return Math.min(...prices)
    }

    const minPrice = getMinPrice()
    const calculatedPrice = calculatePrice(minPrice)

    return (
        <Card className="miniatura">
            <Link to={`/${t("url.marketplace.clubs")}/${passType?.club?.url}/${t("url.marketplace.passTypes")}/${passType?.url}`}>
                <div className="image" variant="top" style={backCardImage}></div>
            </Link>
            <Card.Body>
                <Card.Title>{passType.name}</Card.Title>
                <Row className="mt-2">
                    <Col className="d-flex align-items-center">
                        <img src="/images/pass-people.svg" alt="people" className="me-2"/>                    
                        {t('passTypes.marketplacePeople' ,{ people: passType?.people })}
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col className="d-flex align-items-center">
                        <img src="/images/sector.svg" alt="sector" className="me-2"/>                    
                        {passType?.sector?.name}
                    </Col>
                </Row>
                {/* <Row className="mt-2">
                    <Col className="d-flex align-items-center">
                        <img src={`/images/sports/iconos/${passType?.sport}.svg`} alt="actividad" className="me-2"/>
                        {t('sports.' + (passType?.sport || ''))}
                    </Col>
                </Row> */}
                <Row className="mt-4">
                    <Col className="d-flex align-items-center justify-content-between flex-wrap">
                        <span className="price">
                            {calculatedPrice !== "0.00"
                                ? `${t("global.from")} ${calculatedPrice}€`
                                : "Gratuita"}
                        </span>
                        <Link
                            to={`/${t("url.marketplace.clubs")}/${passType?.club?.url}/${t("url.marketplace.passTypes")}/${passType?.url}`}
                            className="btn btn-primary"
                        >
                            {t("passTypes.buy")}
                            <img src="/images/rignt-arrow.svg" alt="Continuar" className="ms-3"/>
                        </Link>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}